export const NAME_REDUCER = 'giftCard';

export const PREFIX_ACTIONS = 'giftCard_feature_';

export const PATH_LOADING = {
  getGiftCardToBuy: `loading.${NAME_REDUCER}.getGiftCardToBuy`,
  getGiftCardDetail: `loading.${NAME_REDUCER}.getGiftCardDetail`,
};
